document.addEventListener('DOMContentLoaded', () => {
	const headers = Array.from(document.querySelectorAll('.header'));
	if (!headers.length) return;

	const SCROLL_CLASS = 'is-scroll';
	const HOVER_CLOSE_DELAY = 120;

	const updateHeaderScrollState = () => {
		const y =
			window.pageYOffset ||
			document.documentElement.scrollTop ||
			document.body.scrollTop ||
			0;

		headers.forEach((h) => h.classList.toggle(SCROLL_CLASS, y > 0));
	};

	updateHeaderScrollState();
	window.addEventListener('scroll', updateHeaderScrollState, {
		passive: true,
	});
	window.addEventListener('resize', updateHeaderScrollState);

	headers.forEach((root) => {
		const wrappers = Array.from(
			root.querySelectorAll('.bicon-header__mega-menu-wrapper')
		);

		if (wrappers.length) {
			let closeTimer = null;

			const clearCloseTimer = () => {
				if (closeTimer) {
					clearTimeout(closeTimer);
					closeTimer = null;
				}
			};

			const closeAll = () => {
				clearCloseTimer();
				wrappers.forEach((w) => {
					w.classList.remove('is-active');
					const link = w.querySelector('.bicon-header__link');
					if (link) link.classList.remove('is-active');
				});
			};

			const openOne = (wrapper) => {
				clearCloseTimer();
				wrappers.forEach((w) => {
					const active = w === wrapper;
					w.classList.toggle('is-active', active);

					const link = w.querySelector('.bicon-header__link');
					if (link) link.classList.toggle('is-active', active);
				});
			};

			const scheduleCloseAll = () => {
				clearCloseTimer();
				closeTimer = setTimeout(closeAll, HOVER_CLOSE_DELAY);
			};

			wrappers.forEach((wrapper) => {
				const trigger = wrapper.querySelector('.bicon-header__link');
				const menu = wrapper.querySelector('.bicon-header__mega-menu');

				const onEnter = () => {
					clearCloseTimer();
					openOne(wrapper);
				};

				const onLeave = (e) => {
					const to = e.relatedTarget;
					if (to && wrapper.contains(to)) return;
					scheduleCloseAll();
				};

				wrapper.addEventListener('mouseenter', onEnter);
				wrapper.addEventListener('mouseleave', onLeave);

				if (trigger) {
					trigger.addEventListener('mouseenter', onEnter);
					trigger.addEventListener('mouseleave', onLeave);

					trigger.addEventListener('click', (e) => {
						e.preventDefault();
						clearCloseTimer();
						wrapper.classList.contains('is-active')
							? closeAll()
							: openOne(wrapper);
					});
				}

				if (menu) {
					menu.addEventListener('mouseenter', clearCloseTimer);
					menu.addEventListener('mouseleave', (e) => {
						const to = e.relatedTarget;
						if (to && (menu.contains(to) || wrapper.contains(to)))
							return;
						scheduleCloseAll();
					});
				}

				wrapper.addEventListener('focusin', () => openOne(wrapper));
				wrapper.addEventListener('focusout', (e) => {
					if (!wrapper.contains(e.relatedTarget)) scheduleCloseAll();
				});
			});

			document.addEventListener('click', (e) => {
				if (!root.contains(e.target)) closeAll();
			});

			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') closeAll();
			});
		}

		const burgerOpen = root.querySelector('.header__burger-button');
		const burgerClose = root.querySelector('.bicon-header__burger-close');
		const mobileMenu = root.querySelector('.bicon-header__mobile-menu');
		const mobileLinksRoot = root.querySelector(
			'.bicon-header__mobile-menu-links'
		);

		if (mobileLinksRoot) {
			mobileLinksRoot.innerHTML = '';

			const appendLink = (href, text) => {
				const t = (text || '').trim();
				if (!t) return;

				const a = document.createElement('a');
				a.href = href || '#';
				a.textContent = t;
				mobileLinksRoot.appendChild(a);
			};

			const buildFlatLinks = (mega) => {
				const links = Array.from(mega.querySelectorAll('a[href]'))
					.map((a) => ({
						href: a.getAttribute('href') || '#',
						text: (a.textContent || '').trim(),
					}))
					.filter((l) => l.href && l.text);

				const seen = new Set();
				return links.filter((l) => {
					const key = `${l.href}||${l.text}`;
					if (seen.has(key)) return false;
					seen.add(key);
					return true;
				});
			};

			if (wrappers.length) {
				wrappers.forEach((wrapper) => {
					const trigger = wrapper.querySelector(
						'.bicon-header__link'
					);
					if (!trigger) return;

					const href = trigger.getAttribute('href') || '#';
					const label = (trigger.textContent || '').trim();
					const mega = wrapper.querySelector(
						'.bicon-header__mega-menu'
					);

					if (mega) {
						const details = document.createElement('details');
						const summary = document.createElement('summary');

						const summaryLink = document.createElement('a');
						summaryLink.href = href;
						summaryLink.textContent = label;

						summary.appendChild(summaryLink);

						summary.insertAdjacentHTML(
							'beforeend',
							`<svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.0078 1.03125L5.53125 5.32031C5.39062 5.4375 5.25 5.48438 5.13281 5.48438C4.99219 5.48438 4.85156 5.4375 4.73438 5.34375L0.234375 1.03125C0 0.820312 0 0.445312 0.210938 0.234375C0.421875 0 0.796875 0 1.00781 0.210938L5.13281 4.14844L9.23438 0.210938C9.44531 0 9.82031 0 10.0312 0.234375C10.2422 0.445312 10.2422 0.820312 10.0078 1.03125Z" fill="#DF051F"/>
  </svg>`
						);

						const submenu = document.createElement('div');
						submenu.className = 'bicon-header__mobile-submenu';

						buildFlatLinks(mega).forEach((l) => {
							const a = document.createElement('a');
							a.href = l.href || '#';
							a.textContent = l.text;
							submenu.appendChild(a);
						});

						summaryLink.addEventListener('click', (e) => {
							e.preventDefault();
							details.open = !details.open;
						});

						details.appendChild(summary);
						details.appendChild(submenu);
						mobileLinksRoot.appendChild(details);
					} else {
						appendLink(href, label);
					}
				});
			}

			const normalLinks = Array.from(
				root.querySelectorAll('.header__menu a[href]')
			);
			normalLinks.forEach((a) => {
				appendLink(a.getAttribute('href') || '#', a.textContent || '');
			});

			mobileLinksRoot.addEventListener('toggle', (e) => {
				const t = e.target;
				if (!(t instanceof HTMLDetailsElement)) return;
				if (!t.open) return;

				mobileLinksRoot.querySelectorAll('details').forEach((d) => {
					if (d !== t) d.open = false;
				});
			});
		}

		const openMenu = () => {
			root.classList.add('header--menu-open');
			document.body.style.overflow = 'hidden';
		};

		const closeMenu = () => {
			root.classList.remove('header--menu-open');
			document.body.style.overflow = '';

			if (mobileLinksRoot) {
				mobileLinksRoot
					.querySelectorAll('details')
					.forEach((d) => (d.open = false));
			}
		};

		if (burgerOpen) burgerOpen.addEventListener('click', openMenu);
		if (burgerClose) burgerClose.addEventListener('click', closeMenu);

		document.addEventListener('click', (e) => {
			if (!root.classList.contains('header--menu-open')) return;
			if (!mobileMenu || !burgerOpen) return;

			if (
				!mobileMenu.contains(e.target) &&
				!burgerOpen.contains(e.target)
			) {
				closeMenu();
			}
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') closeMenu();
		});
	});
});

document.addEventListener('DOMContentLoaded', () => {
	const switcher = document.querySelector('.header__lang-switcher');
	if (!switcher) return;

	const button = switcher.querySelector('.header__button-lang');
	const current = switcher.querySelector('.header__lang-current');
	const options = switcher.querySelectorAll('.header__lang-option');

	if (!button || !current || !options.length) return;

	const LANGS = ['en'];
	const DEFAULT_LANG = 'de';

	function getSegments(pathname) {
		return pathname.split('/').filter(Boolean);
	}

	function getCurrentLanguage() {
		const segments = getSegments(window.location.pathname);

		if (segments[1] && LANGS.includes(segments[1].toLowerCase())) {
			return segments[1].toUpperCase();
		}

		if (segments[0] && LANGS.includes(segments[0].toLowerCase())) {
			return segments[0].toUpperCase();
		}

		return DEFAULT_LANG.toUpperCase();
	}

	function buildPath(targetLang) {
		const { pathname, search, hash } = window.location;
		const segments = getSegments(pathname);

		if (!segments.length) {
			if (targetLang === 'EN') {
				return `/en/${search}${hash}`;
			}
			return `/${search}${hash}`;
		}

		const firstIsLang = LANGS.includes((segments[0] || '').toLowerCase());
		const secondIsLang = LANGS.includes((segments[1] || '').toLowerCase());

		if (firstIsLang) {
			if (targetLang === 'DE') {
				segments.shift();
			} else {
				segments[0] = targetLang.toLowerCase();
			}
		} else if (secondIsLang) {
			if (targetLang === 'DE') {
				segments.splice(1, 1);
			} else {
				segments[1] = targetLang.toLowerCase();
			}
		} else {
			if (targetLang === 'EN') {
				segments.unshift('en');
			}
		}

		return `/${segments.join('/')}/${search}${hash}`;
	}

	function updateCurrentLabel() {
		current.textContent = getCurrentLanguage();
	}

	function updateActiveOption() {
		const activeLang = getCurrentLanguage();

		options.forEach((option) => {
			const isActive = option.dataset.lang === activeLang;
			option.classList.toggle('is-active', isActive);
			option.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});
	}

	updateCurrentLabel();
	updateActiveOption();

	button.addEventListener('click', () => {
		switcher.classList.toggle('is-open');
		button.setAttribute(
			'aria-expanded',
			switcher.classList.contains('is-open') ? 'true' : 'false'
		);
	});

	options.forEach((option) => {
		option.addEventListener('click', () => {
			const targetLang = option.dataset.lang;
			const newPath = buildPath(targetLang);
			window.location.href = `${window.location.origin}${newPath}`;
		});
	});

	document.addEventListener('click', (e) => {
		if (!switcher.contains(e.target)) {
			switcher.classList.remove('is-open');
			button.setAttribute('aria-expanded', 'false');
		}
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			switcher.classList.remove('is-open');
			button.setAttribute('aria-expanded', 'false');
		}
	});
});

document.addEventListener('DOMContentLoaded', () => {
	const links = document.querySelectorAll('.header__menu-link');
	const currentUrl = new URL(window.location.href);
	const currentPath = currentUrl.pathname.replace(/\/$/, '') || '/';

	links.forEach((link) => {
		const href = link.getAttribute('href');

		if (!href || href === '#' || href.startsWith('#')) return;

		let linkUrl;

		try {
			linkUrl = new URL(href, window.location.origin);
		} catch (e) {
			return;
		}

		const linkPath = linkUrl.pathname.replace(/\/$/, '') || '/';

		if (linkPath === currentPath) {
			link.classList.add('is-active');
		}
	});
});